export enum EstadoOrigemTypes {
  'LOAD_REQUEST' = '@estadoOrigem/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@estadoOrigem/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@estadoOrigem/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@estadoOrigem/CLEAN_MOVIENTRADA',
}
export interface IEstadoOrigem {
  codCid: number;
  codUf: number;
  nome: string;
  siglaEstado: string;
  estado: string;
}

export interface EstadoOrigemState {
  readonly data: IEstadoOrigem[];
  readonly loading: boolean;
  readonly error: boolean;
}
